import React from "react";

const PUBLIC_STOCK_PAGE_BASE = "https://stocks.tickrtrends.com";

// BRK.B -> brk-b, BF/B -> bf-b
const tickerToSlug = (ticker) =>
  String(ticker).trim().toLowerCase().replace(/[./]/g, "-");

// Links a ticker symbol to its public page. Inherits the surrounding
// color/weight so existing table and card styling is unchanged; children
// (e.g. search-highlighted text) render inside the link when provided.
const TickerLink = ({ ticker, children }) => {
  const content = children !== undefined ? children : ticker;

  if (!ticker || String(ticker).trim() === "") {
    return <>{content}</>;
  }

  return (
    <a
      href={`${PUBLIC_STOCK_PAGE_BASE}/${tickerToSlug(ticker)}`}
      style={{
        color: "inherit",
        fontWeight: "inherit",
        textDecoration: "underline",
        textDecorationColor: "rgba(139, 92, 246, 0.5)",
        textUnderlineOffset: "3px",
      }}
    >
      {content}
    </a>
  );
};

export default TickerLink;
